module.exports = __webpack_public_path__ + "img/third_it.933fad69.jpg";